// extracted by mini-css-extract-plugin
module.exports = {"progress":"PageNavLeft_progress__9jtiZ"};